export const getDefaultProfileImage = (name) => {
    let imgUrl = `https://ui-avatars.com/api/?name=${name}&size=75`
    return imgUrl;
}

export const roundTo2Digits = (num) => {
    return Math.round(num * 100) / 100;
}


export const formatSupplierInfo = (supplierInfo) => {
  if (!supplierInfo) return "-";
  if (typeof supplierInfo === "string") return supplierInfo;

  return Object.entries(supplierInfo)
    .map(([key, value]) => `${key}: ${value}`)
    .join(" | ");
};

// Display symbol for a currency code: INR (or empty) shows as ₹, anything else keeps its code.
export const currencySymbol = (code) => (!code || code === "INR" ? "₹" : code);
